import { createFileRoute } from "@tanstack/react-router";
import AdminLogin from "@/pages/AdminLogin";

export const Route = createFileRoute("/admin-login")({
  head: () => ({
    meta: [{ title: "Admin Login | TiemposHoy" }, { property: "og:title", content: "Admin Login | TiemposHoy" }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }, { name: "description", content: "Acceso privado para administradores de TiemposHoy." }, { property: "og:description", content: "Acceso privado para administradores de TiemposHoy." }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: AdminLogin,
});
